// extracted by mini-css-extract-plugin
export default {"loader":"SmallLoader_loader__crZiH","rotation":"SmallLoader_rotation__6G53i"};